import { render, staticRenderFns } from "./T1TripInfoWidgetPart.vue?vue&type=template&id=b6fb057a&scoped=true&"
var script = {}
import style0 from "./T1TripInfoWidgetPart.vue?vue&type=style&index=0&id=b6fb057a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fb057a",
  null
  
)

export default component.exports